import { graphql } from "@/lib/gql/__generated__";

/**
 * 承認では statusRequest などが、非承認（キャンセル）ではそれに加えてキャンセルで変わるフィールドが変わる。
 * 入れ子のオブジェクト（aliveItems* / deadItems）はキャッシュ更新時に丸ごと置き換わるため、
 * 予約詳細クエリ（RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY）と同じ選択にしておくこと。
 */
export const RESERVATION_DETAIL_RESERVATION_REQUEST_HANDLING_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation ReservationDetailReservationRequestHandlingUpdate($input: ReservationRequestHandlingInput!) {
		reservationRequestHandling(input: $input) {
			reservationDetail {
				updatedAt
				statusRequest
				statusReservation
				statusPayment
				canRequestStatusChange
				canCancel
				willCancelPrice
				canUpdate
				canRefund
				canIssueReceipt
				canChargeCancelFee
				willCancelFeeChargePrice
				canHandleLocalPaymentCancelFee
				totalGuestCharge
				aliveItemsPerReservation {
					plan {
						name
						price
						hostInsertedPrice
						discountedPrice
					}
					options {
						name
						amount
						price
						hostInsertedPrice
						discountedPrice
					}
					additionalFees {
						name
						billingTypeTerm
						billingTypeTarget
						unitPrice
						totalPrice
						hostInsertedPrice
						totalDiscountedPrice
					}
					discount {
						name
						discountPrice
					}
					vouchers {
						name
						voucherPrice
					}
				}
				aliveItemsPerDate {
					date
					rooms {
						name
						roomNum {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
						price
						hostInsertedPrice
						discountedPrice
					}
					options {
						name
						amount
						price
						hostInsertedPrice
						discountedPrice
					}
				}
				deadItems {
					plan {
						name
						canceledPrice
					}
					rooms {
						name
						date
						roomNum {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
						canceledPrice
					}
					options {
						name
						dates
						amount
						canceledPrice
					}
					additionalFees {
						name
						billingTypeTerm
						billingTypeTarget
						canceledPrice
					}
				}
			}
			userErrors
		}
	}
`);
